import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import * as FullStory from '@fullstory/browser'
import SentryFullStory from '@sentry/fullstory'
import { LicenseInfo } from '@mui/x-license-pro'
import reportWebVitals from './reportWebVitals'
import App from './App'
import { Suspense } from 'react'
import { tryLoadAndStartRecorder } from '@alwaysmeticulous/recorder-loader'

async function startApp() {
  if (process.env.REACT_APP_STAGE !== 'prod') {
    // Record all sessions on localhost, staging stacks and preview URLs
    await tryLoadAndStartRecorder({
      recordingToken: 'W7y3GoEOlTw8gJRtmHEUUH4Bu5YD4KZOZowkxcJW',
      isProduction: false,
    })
  }
  await import('../i18next.config')
  const sentryEnvironment = process.env.REACT_APP_STAGE === 'prod' ? 'production' : 'development'

  if (process.env.REACT_APP_IS_AMPLIFY_ENV === 'true') {
    FullStory.init({ orgId: '14RVTQ' })

    const tracesSampleRate = sentryEnvironment === 'production' ? 0.75 : 1.0
    Sentry.init({
      dsn: 'https://5a6d4caedea34f0593efe1c5b29bb98a@o966744.ingest.sentry.io/5917787',
      integrations: [new Integrations.BrowserTracing(), new SentryFullStory('greenspark-software')],
      autoSessionTracking: true,
      environment: sentryEnvironment,
      tracesSampleRate,
    })
  }

  if (process.env.REACT_APP_MUI_X_LICENSE_KEY) {
    LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_LICENSE_KEY)
  } else console.warn('No license key found for @mui/x-license-pro')

  ReactDOM.render(
    <Suspense fallback={<div />}>
      <App />
    </Suspense>,
    document.getElementById('root'),
  )

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals()
}

startApp()
